function initSugoiUniversAutoscroll(grid) {
  if (grid.dataset.sugoiAutoscrollInit === 'true') return;
  grid.dataset.sugoiAutoscrollInit = 'true';

  const pxPerSecond = parseFloat(grid.dataset.autoscrollSpeed) || 30;
  const resumeDelayMs = (parseFloat(grid.dataset.autoscrollResumeDelay) || 3) * 1000;
  const mobileQuery = window.matchMedia('(max-width: 999px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const DRAG_CLICK_THRESHOLD = 6; // px of movement before a drag suppresses the tile's link click

  let paused = false;
  let resumeTimer = null;
  let lastFrameTime = null;
  let rafId = null;

  function isActive() {
    return mobileQuery.matches && !reducedMotionQuery.matches;
  }

  function step(timestamp) {
    if (lastFrameTime === null) lastFrameTime = timestamp;
    const deltaSeconds = (timestamp - lastFrameTime) / 1000;
    lastFrameTime = timestamp;

    if (isActive() && !paused) {
      // Native scroll-snap fights a continuously-updated scrollLeft,
      // so it's disabled while we're the ones driving the scroll and
      // restored as soon as the visitor takes over (see markInteraction).
      grid.style.scrollSnapType = 'none';
      const maxScroll = grid.scrollWidth - grid.clientWidth;
      if (maxScroll > 0) {
        let next = grid.scrollLeft + pxPerSecond * deltaSeconds;
        if (next >= maxScroll) {
          next = 0;
        }
        grid.scrollLeft = next;
      }
    }

    rafId = requestAnimationFrame(step);
  }

  function markInteraction() {
    paused = true;
    grid.style.scrollSnapType = '';
    clearTimeout(resumeTimer);
    resumeTimer = setTimeout(() => {
      paused = false;
    }, resumeDelayMs);
  }

  grid.addEventListener('touchstart', markInteraction, { passive: true });
  grid.addEventListener('touchmove', markInteraction, { passive: true });
  grid.addEventListener('wheel', markInteraction, { passive: true });

  // Click-and-drag scrolling (mouse/trackpad/theme editor preview).
  // Pointer events also fire for touch, but native touch scrolling
  // already handles that case, so dragging is only engaged for
  // non-touch pointers to avoid fighting the browser's own touch
  // scroll.
  let isDragging = false;
  let dragMoved = false;
  let dragStartX = 0;
  let dragStartScrollLeft = 0;

  grid.addEventListener('pointerdown', (event) => {
    markInteraction();
    if (event.pointerType === 'touch') return;
    isDragging = true;
    dragMoved = false;
    dragStartX = event.clientX;
    dragStartScrollLeft = grid.scrollLeft;
  });

  grid.addEventListener('pointermove', (event) => {
    if (!isDragging) return;
    const delta = event.clientX - dragStartX;
    if (Math.abs(delta) > DRAG_CLICK_THRESHOLD) {
      if (!dragMoved) {
        // Pointer capture is deferred until a real drag is confirmed
        // (rather than grabbed on every pointerdown): browsers retarget
        // the resulting "click" event to the capturing element while
        // capture is active, which was silently swallowing plain clicks
        // on the tile <a> links on desktop (mouse) before any drag even
        // happened - touch was unaffected since it returns above.
        grid.classList.add('sugoi-univers-grid--dragging');
        grid.setPointerCapture(event.pointerId);
      }
      dragMoved = true;
    }
    grid.scrollLeft = dragStartScrollLeft - delta;
  });

  function endDrag(event) {
    if (!isDragging) return;
    isDragging = false;
    grid.classList.remove('sugoi-univers-grid--dragging');
    if (event.pointerId !== undefined && grid.hasPointerCapture(event.pointerId)) {
      grid.releasePointerCapture(event.pointerId);
    }
  }

  grid.addEventListener('pointerup', endDrag);
  grid.addEventListener('pointercancel', endDrag);

  // Suppress the tile's own link navigation if the pointerdown turned
  // into an actual drag, so dragging the carousel doesn't accidentally
  // open a tile.
  grid.addEventListener(
    'click',
    (event) => {
      if (dragMoved) {
        event.preventDefault();
        event.stopPropagation();
        dragMoved = false;
      }
    },
    { capture: true }
  );

  rafId = requestAnimationFrame(step);

  window.addEventListener('pagehide', () => {
    if (rafId) cancelAnimationFrame(rafId);
    clearTimeout(resumeTimer);
  });
}

function initAllSugoiUniversAutoscroll(root = document) {
  root.querySelectorAll('[data-sugoi-autoscroll]').forEach(initSugoiUniversAutoscroll);
}

document.addEventListener('DOMContentLoaded', () => initAllSugoiUniversAutoscroll());

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initAllSugoiUniversAutoscroll(event.target));
}
